import type { RouteObject } from 'react-router';
import MainLayout from '~/ui/layout/MainLayout';
import SandboxHomePage from '~/pages/sandbox/SandboxHomePage';
import SandboxDashboardLayout from '~/pages/sandbox/dashboard/SandboxDashboardLayout';
import SandboxDashboardHome from '~/pages/sandbox/dashboard/SandboxDashboardHome';
import SandboxDashboardItems from '~/pages/sandbox/dashboard/SandboxDashboardItems';
import SandboxWidgetLayout from '~/pages/sandbox/widget/SandboxWidgetLayout';
import SandboxWidgetStep1 from '~/pages/sandbox/widget/SandboxWidgetStep1';
import SandboxWidgetStep2 from '~/pages/sandbox/widget/SandboxWidgetStep2';
import SandboxWidgetSuccess from '~/pages/sandbox/widget/SandboxWidgetSuccess';
import SandboxSettingsPage from '~/pages/sandbox/SandboxSettingsPage';
import BrowserAdapterDemoPage from '~/pages/sandbox/BrowserAdapterDemoPage';

/**
 * Sandbox Routes - For testing and demonstration
 * These routes showcase routing patterns and layouts
 * 
 * TODO: Remove these routes once production features are implemented
 */
export const sandboxRoutes: RouteObject[] = [
  // Routes with MainLayout (header + footer)
  {
    path: 'sandbox',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <SandboxHomePage />,
      },
      {
        path: 'dashboard',
        element: <SandboxDashboardLayout />,
        children: [
          {
            index: true,
            element: <SandboxDashboardHome />,
          },
          {
            path: 'items',
            element: <SandboxDashboardItems />,
          },
        ],
      },
      {
        path: 'settings',
        element: <SandboxSettingsPage />,
      },
      {
        path: 'browser-adapter',
        element: <BrowserAdapterDemoPage />,
      },
    ],
  },
  
  // Routes without MainLayout (custom layout)
  {
    path: 'sandbox/widget',
    element: <SandboxWidgetLayout />,
    children: [
      {
        index: true,
        element: <SandboxWidgetStep1 />,
      },
      {
        path: 'step-2',
        element: <SandboxWidgetStep2 />,
      },
      {
        path: 'success',
        element: <SandboxWidgetSuccess />,
      },
    ],
  },
];
